// @flow
import React from "react";
import I18n from "../../../i18n/I18n";
import Button from "../button/Button";
import styles from "./EmptyResults.scss";

type Props = {
  type: string,
  handleBtnClick: Function,
  status: number
};

const EmptyResults = (props: Props) => {
  let heading = props.heading || "";
  let buttonText = null;

  const { status, fmIntegrated, style } = props;

  let statusText = I18n.getText("orders.new");

  switch (status) {
    case 1:
      statusText = I18n.getText("orders.new");
      break;
    case fmIntegrated && 3:
      statusText = I18n.getText("orders.ready-for-pickup");
      break;
    case fmIntegrated && 4:
      statusText = I18n.getText("orders.picked");
      break;
    case fmIntegrated && 5:
      statusText = I18n.getText("orders.received");
      break;
    case 2:
      statusText = I18n.getText("orders.accepted");
      break;
    case fmIntegrated ? 6 : 3:
      statusText = I18n.getText("orders.completed");
      break;
    case fmIntegrated ? 7 : 4:
      statusText = I18n.getText("orders.cancelled");
      break;
    case fmIntegrated ? 8 : 5:
      statusText = I18n.getText("orders.returns");
      break;
    default:
      statusText = I18n.getText("orders.new");
  }

  switch (props.type) {
    case "orders":
      heading = I18n.getText("empty-state.no-items", {
        status: statusText
      });
      break;

    case "products":
      heading = I18n.getText("empty-state.no-offers", {}, "No Products Found");
      break;

    case "order":
      heading = I18n.getText(
        "empty-state.no-order-single",
        {},
        "Invalid Order Number"
      );
      buttonText = I18n.getText("empty-state.back-btn", {}, "Go Back");
      break;

    case "statement":
      heading = I18n.getText(
        "empty-state.no-statement",
        {},
        "Invalid Statement Number"
      );
      buttonText = I18n.getText("empty-state.back-btn", {}, "Go Back");
      break;

    case "product":
      heading = I18n.getText("empty-state.no-product", {}, "No Product Found");
      buttonText = I18n.getText("empty-state.back-btn", {}, "Go Back");
      break;

    case "payments":
      heading = I18n.getText(
        "empty-state.no-payments",
        {},
        "You don’t have any payments"
      );
      buttonText = I18n.getText("empty-state.clear-date", {}, "Clear Filters");
      break;

    case "creditNotes":
      heading = I18n.getText(
        "empty-state.no-creditnotes",
        {},
        "You don’t have any credit notes"
      );
      buttonText = null;
      break;

    case "invoices":
      heading = I18n.getText(
        "empty-state.no-invoices",
        {},
        "You don’t have any invoice"
      );
      buttonText = null;
      break;

    case "noonInvoices":
      heading = I18n.getText(
        "empty-state.no-noon-invoices",
        {},
        "You don’t have any noon invoice"
      );
      buttonText = null;
      break;

    case "reserve":
      heading = I18n.getText(
        "empty-state.no-reserve",
        {},
        "You don’t have any reserved Items"
      );
      buttonText = null;
      break;

    case "page404":
      heading = I18n.getText(
        "empty-state.page-missing",
        {},
        "404. Sorry, it looks like this page is missing."
      );
      buttonText = null;
      break;

    case "connection":
      heading = I18n.getText("empty-state.no-connection");
      buttonText = null;
      break;

    default:
      heading = props.heading || I18n.getText("empty-state.page-missing");
      buttonText = null;
      break;
  }

  return (
    <div
      className={`${styles.maBoxWrapper} ${
        !props.type || props.fullPage ? styles.fullPage : ""
      }`}
      style={style}
    >
      <div className={styles.emptyResultsCtr}>
        <div className={styles.content}>
          <div className={styles.dataRow}>
            <span className={styles.largeText}>{heading}</span>
          </div>

          {buttonText &&
            props.handleBtnClick && (
              <div className={styles.dataRow}>
                <Button
                  variant="primary"
                  onClick={props.handleBtnClick}
                  className={styles.thinButton}
                >
                  {buttonText}
                </Button>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default EmptyResults;



// WEBPACK FOOTER //
// ./src/components/common/emptyResults/EmptyResults.js